import { PROCESS_STEPS } from "@/lib/site";
import Reveal from "@/components/Reveal";

export default function Process() {
  return (
    <section
      data-testid="process-section"
      id="process"
      className="relative bg-[#080A0B] py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-16 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="flex items-center gap-4 mb-8">
            <span className="block w-10 h-px bg-[#3FB8DC]" />
            <span className="eyebrow">How we work</span>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[#F4F0EB] leading-[1.02] tracking-tight max-w-4xl">
            Reliable service, clear communication and <span className="italic text-[#A1A1AA]">quality workmanship </span>
            <span className="text-[#3FB8DC]">every step of the way.</span>
          </h2>
        </Reveal>

        <div className="mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-[#27272A]">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal
              key={step.no}
              delay={i * 120}
              className="relative bg-[#080A0B] p-8 md:p-10 min-h-[260px] hover:bg-[#0E1213] transition-colors duration-500"
            >
              <div data-testid={`process-step-${step.no}`}>
                <span
                  className="absolute top-6 right-8 font-serif-display text-[8rem] leading-none text-[#27272A] select-none"
                  aria-hidden
                >
                  {step.no}
                </span>
                <div className="relative">
                  <span className="eyebrow" style={{ fontSize: "0.6rem" }}>
                    Step {step.no}
                  </span>
                  <h3 className="font-serif-display text-2xl md:text-3xl text-[#F4F0EB] mt-4 leading-tight">
                    {step.title}
                  </h3>
                  <p className="mt-5 text-[#A1A1AA] text-sm leading-relaxed">{step.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
